import React, { Component } from 'react';

export default class ProfileInfo extends Component {

	render () {
		const { info, icon, title } = this.props;
        let labelHtml = <span className={icon}></span>;
		if(!icon) labelHtml = <span className='info-label'>{title}: </span>;
		return (
			<blockquote className="member-info" title={title}>{labelHtml}{info}</blockquote>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/members/profileInfo.js